import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserState } from '../state/current-user.state';

/**
 * Guard that allows only users holding the Keycloak `developer` realm role. Used for developer-only
 * views (e.g. the manually-accessed `/auditlog`). This is independent of the DB-based AppUserRole —
 * not even an Admin passes without the role assigned in Keycloak.
 *
 * Usage in routes:
 * {
 *   path: 'auditlog',
 *   component: AuditLogListComponent,
 *   canActivate: [authGuard, developerGuard]
 * }
 */
export const developerGuard: CanActivateFn = () => {
  const currentUserState = inject(CurrentUserState);
  const router = inject(Router);

  if (currentUserState.isDeveloper()) {
    return true;
  }

  console.warn('Access denied: developer role required');
  router.navigate(['/forbidden']);
  return false;
};
